export const PLATFORM_URLS = {
  local: {
    artist: 'http://localhost:3001',
    curator: 'http://localhost:3000',
  },
  dev: {
    artist: 'https://submission-v2.songplace.io',
    curator: 'https://curator-dev.songplace.io',
  },
  prod: {
    artist: 'https://www.songplace.io',
    curator: 'https://curator.songplace.io',
  },
};
